export function parseDateString(dateString) {
    const date = new Date(dateString);
    // Note: Month is 0-based in JavaScript Date object, so subtract 1 from month
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
};
